import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import { Maps } from '../routes/Maps';
import { useCognitoUser } from '../hooks/useCognitoUser';
import { Navigate, Route, Routes } from 'react-router-dom';
import Box from '@mui/material/Box';
import { SystemConfigurations } from '../routes/SystemConfigurations';
import { ProtectedRoute } from './ProtectedRoute';
import {
    ROLES_WITH_DEVICE_VIEW,
    ROLES_WITH_MAPS_ACCESS,
    ROLES_WITH_CONFIGURATIONS_ACCESS,
    ROLES_WITH_ORGANIZATIONS_ACCESS,
} from '../permissions';
import { Organizations } from '../routes/Organizations';
import Drawer from '@mui/material/Drawer';
import { Logout } from './Logout';
import Divider from '@mui/material/Divider';
import { SidebarList } from './SidebarList';
import { Devices } from '../routes/Devices';

const drawerWidth = 240;

export default function Layout() {
    const { userRoles, user } = useCognitoUser();

    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <Toolbar>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-end',
                            width: '100%',
                        }}
                    >
                        <Logout />
                    </Box>
                </Toolbar>
                <Divider />
                <SidebarList />
            </Drawer>

            <Box
                component="main"
                sx={{
                    bgcolor: 'background.default',
                    width: `calc(100% - ${drawerWidth}px)`,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                {user && userRoles ? (
                    <Routes>
                        <Route
                            path="maps/*"
                            element={
                                <ProtectedRoute allowedRoles={ROLES_WITH_MAPS_ACCESS}>
                                    <Maps />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="devices/*"
                            element={
                                <ProtectedRoute allowedRoles={ROLES_WITH_DEVICE_VIEW}>
                                    <Devices />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="configurations"
                            element={
                                <ProtectedRoute allowedRoles={ROLES_WITH_CONFIGURATIONS_ACCESS}>
                                    <SystemConfigurations />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="organizations"
                            element={
                                <ProtectedRoute allowedRoles={ROLES_WITH_ORGANIZATIONS_ACCESS}>
                                    <Organizations />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="devices" replace />} />
                    </Routes>
                ) : (
                    <></>
                )}
            </Box>
        </Box>
    );
}
